import {
  getNamespaceLabel,
  getAttributeKeyLabel,
  getAttributeKeys,
  getTypeForNode,
  getMemberKey,
  getMemberKeys,
  getRelationkeyLabel,
  getNodeLabel,
  getUid
  splitUid
} from 'Services/WeaverUtils'
import * as Types from 'Types'
import { getDisabledRelations, getDisabledTypes } from 'Services/WeaverUtils'
import ColorService from 'Services/ColorService'
import { store } from '~/Store'
import { updateRelationFilters, updateTypeFilters } from 'Actions/graphFilter'
import SizeService from 'Services/SizeService'

memberKey = null

nodes = {}
relNodes = {}
edges = {}
groups = {}
querySelects = {
  in: []
  out: []
}

clear = ->
  memberKey = getMemberKey()
  nodes = {}
  relNodes = {}
  edges = {}
  groups = {}
  querySelects = {
    in: []
    out: []
  }

nodeHasRelations = (node) ->
  _.keys(node.relations()).length > 0 or _.keys(node._relationsIn).length > 0

getType = (node) ->
  { explore: { typesMap }} = store.getState()
  result = []
  for memberKey in getMemberKeys()
    for t in node.relation(memberKey).all()
      if t?
        id = getUid(t)
        result.push(typesMap[id])
  result

addNode = (node) ->
  { explore: { typesMap }, graphFilter: { hideNamelessNodeLabels }} = store.getState()
  id = getUid(node)
  isType = typesMap[id]?

  if node._loaded
    nodes[id] = {
      nodes[id]...
      id
      label: getNodeLabel(node)
      isType
      type: getType(node)
      graph: node.getGraph()
      labels: node.getLabels() or []
      group: if isType then "#{getGroupForType(id)}" else "#{getGroup(node)}"
    }

addRelNode = (node, key) ->
  { explore: { typesMap }, graphFilter: { hideRelationLabels }} = store.getState()
  id = getUid(node)
  isType = typesMap[id]?
  relNodes[id] = {
    relNodes[id]...
    id
    isType
    type: getType(node)
    shape: 'hexagon'
    graph: node.getGraph()
    label: if hideRelationLabels then ' ' else getRelationkeyLabel(key, id)
    key
    _label: getRelationkeyLabel(key, id)
    group: getGroupForRel(key)
  }

addEdge = (key, source, target, relNode) ->
  { graphFilter: { showRelationsAsNodes, hideRelationLabels }} = store.getState()
  id = getUid(relNode)
  sourceId = getUid(source)
  targetId = getUid(target)

  selfReferenceSize = (10 * (_.filter(edges, (edge) ->
    edge.from is sourceId and edge.to is targetId and targetId is sourceId
  ).length)) + 20

  if target._loaded
    edges[id] = {
      id
      _id: id
      from: sourceId
      _from: sourceId
      to: targetId
      selfReference: {
        size: edges[id]?.selfReference?.size or selfReferenceSize
      }
      _to: targetId
      label: if hideRelationLabels then ' ' else getRelationkeyLabel(key, id)
      _label: getRelationkeyLabel(key, id)
      graph: relNode.graph
      hasRelations: _.size(relNode.relations()) > 0
      key
      physics: sourceId isnt targetId
      scaling: {
        label: false
        max: 6
      }
    }

shouldFilterRelations = (selects) ->
  return true unless ('*' in selects or _.isEmpty(selects))

relationsToEdges = (node) ->
  outs = []
  ins = []
  _.map(_.filter(node.relations(), (rel) ->
    if shouldFilterRelations(querySelects.out)
      rel.key in querySelects.out
    else
      true
  ), (rel) ->
    rel.allRecords().map((record) ->
      { fromNode, toNode, relNode } = record
      addEdge(rel.key, fromNode, toNode, relNode)
    )
    outs = rel.all()
    traverseRelations(rel.all())
  )

  ins = _.map(_.filter(node._relationsIn, (rel) ->
    if shouldFilterRelations(querySelects.in)
      rel.key in querySelects.in
    else
      true
  ), (rel) ->
    rel.allRecords().map((record) ->
      { fromNode, toNode, relNode } = record
      addEdge(rel.key, fromNode, toNode, relNode)
    )

    ins = rel.all()
    traverseRelations(rel.all())
  )
  [...outs, ...ins]

traverseRelations = (nodes) ->
  nodes.map((node) ->
    relationsToEdges(node)
    if node instanceof Weaver.RelationNode
      addRelNode(node)
    else
      addNode(node)
  )

preApplyFilters = ->
  disabledRelations = getDisabledRelations() or []
  disabledTypes = getDisabledTypes() or []

  store.dispatch(updateRelationFilters(
    _.keyBy(
      disabledRelations.map((disabledRelation) ->
        {
          key: disabledRelation
          enabled: false
          label: getRelationkeyLabel(disabledRelation)
        }
      )
    , 'key')
  ))
  store.dispatch(updateTypeFilters(
    _.keyBy(
      disabledTypes.map((disabledType) ->
        {
          id: disabledType
          enabled: false
          label: disabledType
        }
      )
    , 'id')
  ))

export loadGraphDataFromNodes = (result, query) ->
  clear()
  if query
    querySelects.in = _.flatten(query._selectIn)
    querySelects.out = _.flatten(query._selectOut)
  { graphFilter: { showRelationsAsNodes }} = store.getState()
  preApplyFilters()
  traverseRelations(result)

  if showRelationsAsNodes
    toggleRelationNodes(nodes, relNodes, edges, groups, showRelationsAsNodes)
  else
    { abstract: false, nodes, relNodes: {}, edges, groups }

export loadGraphData = (query) ->
  if query instanceof Weaver.Sparql
    results = await query.findNodes()
  else
    results = await query.withRelations().find()
  loadGraphDataFromNodes(results, query)

export loadAbstractGraphData = (id, memberKey = getMemberKey()) ->
  clear()
  if id?
    [id, graph] = splitUid(id)
    nodeResult = await Weaver.MetaQueries.typesAndCountForId(id, getAttributeKeys(), memberKey, { limit: 99999 })
  else
    nodeResult = await Weaver.MetaQueries.typesAndCount(getAttributeKeys(), memberKey, { limit: 99999 })

  relationResult = await Weaver.MetaQueries.relationsAndCount(memberKey, { limit: 99999 })

  nodeResult.map(({ uid, label, count, graph }) ->
    if label is 'null' or label is undefined then label = uid
    id = getUid(uid, graph)
    nodes[id] = {
      id
      graph: splitUid(id)[1]
      label: "#{getNamespaceLabel(label)} (#{count})"
      group: getGroupForAbstractType(uid)
      value: count
      labels: []
    }
  )

  relationResult.map(({ label, source, target, count, sourceGraph, targetGraph }) ->
    source = getUid(source, sourceGraph)
    target = getUid(target, targetGraph)

    selfReferenceSize = (10 * (_.filter(edges, (edge) ->
      edge.from is source and edge.to is target and target is source
    ).length)) + 20

    if nodes[source]? and nodes[target]?
      id = "#{source}->#{label}->#{target}"
      edges[id] = {
        id
        from: source
        to: target
        label: "#{getRelationkeyLabel(label, id)} (#{count})"
        _label: "#{getRelationkeyLabel(label, id)} (#{count})"
        key: getRelationkeyLabel(label, id)
        value: count
        selfReference: {
          size: edges[id]?.selfReference?.size or selfReferenceSize
        }
        physics: source isnt target
        scaling: {
          label: false
          max: 6
        }
      }
  )

  { abstract: true, nodes, relNodes, edges, groups }

export loadAbstractAttributeData = (key) ->
  clear()
  nodes = await new Weaver.Query()
    .exists(key)
    .unlimited()

  sources = nodes.map((node) ->
    getUid(node)
  )

  sourceCount = "#{sources.length}"

  sourceNode = {
    id: 'source'
    group: getGroupForType('undefined')
    sources
    label: "#{getAttributeKeyLabel(key)} (#{sourceCount})"
    value: sourceCount
  }

  nodes = _.keyBy([
    sourceNode
  ], 'id')

  { abstract: Types.ATTRIBUTE_VIEW, nodes, edges, relNodes, groups }

export loadAbstractRelationData = (key) ->
  clear()
  nodes = await new Weaver.Query()
    .hasRelationOut(key)
    .unlimited()

  sources = nodes.map((node) ->
    getUid(node)
  )
  sourceCount = "#{sources.length}"

  targets = _.uniq(nodes.reduce((acc, node) ->
    [
      acc...
      node.relation(key).all().map((target) ->
        getUid(target)
      )...
    ]
  , []))

  targetCount = "#{targets.length}"

  sourceNode = {
    id: 'source'
    group: getGroupForType('undefined')
    sources
    label: sourceCount
    value: sourceCount
  }

  targetNode = {
    id: 'target'
    group: getGroupForType('undefined')
    targets
    label: targetCount
    value: targetCount
  }

  nodes = _.keyBy([
    sourceNode
    targetNode
  ], 'id')

  edges = _.keyBy([{
    noAttributes: true
    id: key
    label: getRelationkeyLabel(key)
    from: 'source'
    to: 'target'
  }], 'id')

  { abstract: Types.RELATION_VIEW, nodes, edges, relNodes, groups }

export expandNodes = (ids) ->
  clear()
  preApplyFilters()

  ids = _.map(ids, (id) -> splitUid(id)[0])
  result = await new Weaver.Query()
    .restrict(ids)
    .selectOut('*')
    .selectIn('*')
    .find()

  traverseRelations(result)

  { canonicalNodes: result, graphData: { nodes, relNodes, edges, groups } }

export expandNode = (id) ->
  { graph: { graphData: { nodes, edges }}, graphFilter: { showRelationsAsNodes }} = store.getState()
  [id, graph] = splitUid(nodes[id].wvrId)
  clear()
  preApplyFilters()
  nodes = { nodes... }
  edges = { edges... }

  query = new Weaver.Query()
    .restrict(id)
    .inGraph(graph)
    .selectOut('*')
    .selectIn('*')

  node = await query.withRelations().withAttributes().first()

  if showRelationsAsNodes
    toggleRelationNodes(nodes, relNodes, edges, groups, showRelationsAsNodes)
  else
    { nodes, relNodes, edges, groups }

export expandAbstractNode = (id) ->
  clear()

  nodeResult = await Weaver.MetaQueries.typesAndCount(id, getAttributeKeys(), memberKey, { limit: 99999 })
  relationResult = await Weaver.MetaQueries.relationsAndCount(memberKey, { limit: 99999 })

  nodeResult.map((type) ->
    { uid, label, count } = type
    if label is "null" then label = uid
    nodes[uid] = {
      id: uid
      label: "#{getNamespaceLabel(label)} (#{count})"
      color: ColorService.getColorForType(uid)
      value: count
      labels: []
    }
  )

  relationResult.map((relation) ->
    { label, source, target, count } = relation
    if nodes[source]? and nodes[target]?
      id = "#{source}->#{label}->#{target}"
      edges[id] = {
        id
        from: source
        to: target
        label: "#{getRelationkeyLabel(label, id)} (#{count})"
        key: getRelationkeyLabel(label, id)
        value: count
        physics: source isnt target
        scaling: {
          label: false
          max: 6
        }
      }
  )

  { nodes, relNodes, edges, groups }

export toggleRelationLabels = (edges, hide) ->
  edges = _.reduce(edges, (acc, edge, id) ->
    if not edge.intermediate
      acc[id] = {
        edge...
        label: if hide then ' ' else edge._label
      }
    acc
  , {})

  { edges }

export toggleNodeLabels = (nodes, hide) ->
  nodes = _.reduce(nodes, (acc, node, id) ->
    acc[id] = {
      node...
      label: if hide and node.id is node.label then ' ' else node._label
    }
    acc
  , {})

  { nodes }

defaultEdgeMetaData = (edge) ->
  _id: edge.id
  _from: edge.from
  _to: edge.to

edgeArrowDefault =
  intermediate: false
  arrowStrikethrough: false
  arrows:
    to: true

edgeArrowCenter =
  intermediate: true
  arrowStrikethrough: true
  arrows:
    to: false
    middle:
      enabled: true
      scaleFactor: 0.5

export toggleRelationNodes = (prevNodes, prevRelNodes, prevEdges, prevGroups, show) ->
  { graph: { graphData: { abstract }}} = store.getState()
  clear()

  return {
    nodes: prevNodes
    relNodes: prevRelNodes
    edges: prevEdges
    groups: prevGroups
  } if abstract

  idsToChange = _.keys(prevEdges).map((uid) -> splitUid(uid)[0])

  if show
    edgesToChange = await new Weaver.Query()
      .restrict(idsToChange)
      .selectOut('*')
      .selectIn('*')
      .withRelations()
      .find()

    # Not all results are rel nodes
    edgesToChange = edgesToChange.reduce((acc, rel) ->
      if rel instanceof Weaver.RelationNode and nodeHasRelations(rel)
        addRelNode(rel, rel.key)
        acc.push(getUid(rel))
      acc
    , [])

    edges = _.reduce(prevEdges, (acc, edge) ->
      if edge.id in edgesToChange
        acc["#{edge.from}->#{edge.id}"] = {
          edge...
          defaultEdgeMetaData(edge)...
          id: "#{edge.from}->#{edge.id}"
          label: ' '
          from: edge.from
          to: edge.id
          key: edge.key
          edgeArrowCenter...
        }

        acc["#{edge.id}->#{edge.to}"] = {
          edge...
          defaultEdgeMetaData(edge)...
          id: "#{edge.id}->#{edge.to}"
          label: ' '
          from: edge.id
          to: edge.to
          key: edge.key
          edgeArrowCenter...
        }
      else
        acc[edge.id] = {
          edge...
          defaultEdgeMetaData(edge)...
          key: edge.key
        }

      acc
    , {})

    relNodesToShow = _.reduce(relNodes, (acc, relNode, id) ->
      if id in edgesToChange
        acc[id] = relNode
      acc
    , {})
    nodes = {
      prevNodes...
      relNodesToShow...
    }
  else
    edges = _.reduce(prevEdges, (acc, edge) ->
      acc[edge._id] = {
        edge...
        id: edge._id
        from: edge._from
        to: edge._to
        label: edge._label
        key: edge.key
        edgeArrowDefault...
      }
      acc
    , {})

    nodes = _.reduce(prevNodes, (acc, node, id) ->
      if not prevRelNodes[id]?
        acc[id] = node
      acc
    , {})

  groups = {
    groups...
    prevGroups...
  }

  { nodes, relNodes, edges, groups, abstract }



export createRelationInGraph = (relKeys, fromIds, toIds) ->
  clear()
  currentGraphNodes = store.getState().graph.graphData.nodes
  hideRelationLabels = localStorage.getItem('hideRelationLabels') is 'true'
  if not _.isArray(fromIds)
    fromIds = [fromIds]
  if not _.isArray(toIds)
    toIds = [toIds]
  if not _.isArray(relKeys)
    relKeys = [relKeys]

  fromNodes = await Promise.map(fromIds, (fromId) ->
    [fromId, fromGraph] = splitUid(fromId)
    new Weaver.Query()
      .restrict([fromId])
      .inGraph(fromGraph)
      .withRelations()
      .first()
  )

  toIds = _.reduce(toIds, (acc, toId) ->
    [toId, toGraph] = splitUid(toId)
    acc[toGraph] ?= []
    acc[toGraph] = [
      acc[toGraph]...
      toId
    ]
    acc
  , {})

  toNodes = _.flatten(await Promise.all(_.map(toIds, (toIds, toGraph) ->
    toGraph = undefined if toGraph is 'undefined'
    new Weaver.Query()
      .restrict(toIds)
      .withRelations()
      .inGraph(toGraph)
      .find()
  )))

  relNodes = _.flattenDeep(_.map(relKeys, (relKey) ->
    _.map(toNodes, (toNode) ->
      _.map(fromNodes, (fromNode) ->
        relNode = fromNode.relation(relKey).add(toNode)
        relNode.key = relKey
        relNode
      )
    )
  ))

  await Weaver.Node.batchSave(fromNodes, { commitMessage: "Create relation(s) in graph view." })

  newGroups = {}
  newNodes = {}

  _.map(relKeys, (relKey) ->
    if relKey in getMemberKeys()
      fromGraphNodes = fromNodes.map((fromNode) ->
        currentGraphNodes[getUid(fromNode)]
      )
      toGraphNodes = toNodes.map((toNode) ->
        if currentGraphNodes[getUid(toNode)]
          currentGraphNodes[getUid(toNode)]
        else
          addNode(toNode)
      )

      toGraphNodes.map((toGraphNode) ->
        if not toGraphNode.group? or toGraphNode.group is 'undefined'
          color = ColorService.getColorForType(toGraphNode.id)
          newGroups = {
            newGroups...
            [toGraphNode.id]: { color }
          }
          newNodes[toGraphNode.id] = {
            toGraphNode...
            group: "#{toGraphNode.id}"
          }
      )

      fromNodes.map((fromNode) ->
        fromGraphNode = currentGraphNodes[getUid(fromNode)]
        newNodes[fromGraphNode.id] = {
          fromGraphNode...
          label: getNodeLabel(fromNode)
          group: "#{getTypeForNode(fromNode)}"
        }
      )
  )

  toNodes.map((node) ->
    if not newNodes[getUid(node)] and not currentGraphNodes[getUid(node)]
      addNode(node)
  )

  fromNodes.map((node) ->
    if not newNodes[getUid(node)] and not currentGraphNodes[getUid(node)]
      addNode(node)
  )

  newNodes = {
    newNodes...,
    nodes...
  }

  newGroups = {
    newGroups...
    groups...
  }

  newEdges = relNodes.reduce((acc, relNode) ->
    { key, fromNode, toNode } = relNode

    relNodeId = relNode.id()
    fromId = getUid(fromNode)
    toId = getUid(toNode)

    acc[relNode.id()] = {
      id: relNodeId
      _id: relNodeId
      from: fromId
      to: toId
      _from: fromId
      _to: toId
      label: if hideRelationLabels then ' ' else getRelationkeyLabel(key, relNodeId)
      _label: getRelationkeyLabel(key, relNodeId)
      key: getRelationkeyLabel(key, relNodeId)
      physics: fromId isnt toId
    }
    acc
  , {})

  { nodes: newNodes, edges: newEdges, groups: newGroups }
